import React, { Dispatch, SetStateAction } from 'react';
import { IAttendeeOrganizationDTO } from '../../../../../../../api/attendees.dao';
import { OptionIcon, OptionIconChecked } from '../../../../../../global/oe-radio-options/option-icon';
import Text from '../../../../../../global/text/text';
import { IEntityData } from './make-assign-to-participant-form-in-popover';

interface IProps {
    itemsList: IAttendeeOrganizationDTO[];
    onSelectItem: Dispatch<SetStateAction<number>>;
    onSetEntity: Dispatch<SetStateAction<IEntityData>>;
    selectedItem: number | null;
}

const ParticipantsList = (props: IProps) => {
    const {
        itemsList,
        onSelectItem,
        selectedItem,
        onSetEntity,
    } = props;

    return (
        <div className='entity-list'>
            {
                itemsList.slice()
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(org => {
                    const organizationId = org.organizationId;
                    return (
                        <div className='entity-organization' key={organizationId}>
                            <div className='entity-organization__header'>
                                <Text message={org.name} withEllipsis />
                            </div>
                        {
                            org.attendees
                            .slice()
                            .sort((a, b) => a.lastName.localeCompare(b.lastName))
                            .map(attendee => {
                                const attendeeId = attendee.attendeeId;
                                return (
                                    <div
                                        key={`${org.name}_${attendeeId}`}
                                    >
                                        <input
                                            type='radio'
                                            className='oe-radio-option__control'
                                            id={`radio-button-${attendeeId}`}
                                            name={'itemsName'}
                                        />
                                        <label
                                            className='entity-organization__attendee'
                                            htmlFor={`radio-button-${attendeeId}`}
                                            onClick={e => {
                                                e.stopPropagation();
                                                onSetEntity({
                                                    attendeeEntityId: attendeeId,
                                                    orgEntityId: organizationId,
                                                    orgRole: attendee.attendeOrganizationRole,
                                                });
                                                onSelectItem(attendeeId);
                                            }}
                                        >
                                            {selectedItem === attendeeId ? <OptionIconChecked /> : <OptionIcon />}
                                            <Text
                                                message={`${attendee.firstName} ${attendee.lastName}`}
                                                withEllipsis
                                            />
                                        </label>
                                    </div>
                                );
                            })
                        }
                        </div>
                    );
                })
            }
        </div>
    );
};

export default ParticipantsList;
